// extracted by mini-css-extract-plugin
export default {"nav":"AppNav_nav__R2pe4","home":"AppNav_home__C4Tdn","right":"AppNav_right__eLPOn"};